<template>
  <v-container fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center>
      <v-flex xs12 md6 offset-md3>
        <v-form
          @submit.prevent="submitLoginForm"
        >
          <v-container v-show="currentForm=='login'">
            <div class="container-login">
              <v-flex xs8 offset-xs2 style="padding-top: 150px;" class="box-white">
                <v-text-field
                  v-model="username"
                  required
                  color="#091D3B"
                  label="Username"
                  box
                >
                </v-text-field>
                <v-text-field
                  v-model="password"
                  required
                  label="Password"
                  box
                  :type="'password'"
                  color="#091D3B"
                >
                </v-text-field>
                <v-btn
                  block
                  type="submit"
                  class="button-style-blue"
                  dark
                >
                  Login
                </v-btn>
                <a href="#" v-on:click.prevent="toggleForm()" class="text-main forgot-password">Forgot Password</a>
              </v-flex>
            </div>
          </v-container>
          <v-container v-show="currentForm=='passwordReset'">
            <div class="container-login">
              <v-flex xs8 offset-xs2 style="padding-top: 150px;" class="box-white">
                <v-text-field
                  v-model="email"
                  required
                  color="#091D3B"
                  label="Email"
                  box
                >
                </v-text-field>
                <v-btn
                  block
                  type="submit"
                  @click="submitResetForm"
                  class="button-style-blue"
                  dark
                >
                  Submit
                </v-btn>
              </v-flex>
            </div>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Login",
  data () {
    return {
      username: null,
      password: null,
      email: null,
      currentForm: "login"
    }
  },
  methods: {
    ...mapActions(["login", "forgotPassword"]),
    submitLoginForm () {
      if (this.username && this.password) {
         this.login({ username: this.username, password: this.password })
        .then(() => {
          this.$toastr("success", `Welcome ${this.username}`, "")
          this.$router.push({ name: "home" })
        })
        .catch(() => {
          this.$toastr("error", "Username or Password is incorrect", "error")
        })
      }
    },
    submitResetForm () {
      let self = this;
      this.forgotPassword({ email: this.email })
        .then(() => {
          self.$toastr("info", "Check your email inbox", "info");
        })
        .catch(() => {
          self.$toastr("error", "Password reset failed", "error");
        });
    },
    toggleForm () {
      this.currentForm = this.currentForm === "login" ? "passwordReset" : "login";
    }
  }
}
</script>
